import React from 'react';
import { Switch } from '@headlessui/react';

function ToggleInput({
	value,
	onChange = () => {},
	colors,

	/* Optional props */
	styleDIV,
	classNameDIV = 'relative inline-flex focus:outline-none outline-none flex-shrink-0 items-center h-5 w-10 border rounded-full cursor-pointer',
	styleSPAN,
	classNameSPAN = 'pointer-events-none inline-block h-4 w-4 rounded-full shadow-lg',
}) {
	/* Default values for the styles */
	const defaultStyleDIV = {
		backgroundColor: value ? colors?.primary : colors?.secondary,
		border: `1px solid ${colors?.primary}`,
		transition: 'all 300ms ease-in'
	};
	const defaultStyleSPAN = {
		backgroundColor: value ? colors?.secondary : colors?.primary,
		transform: value ? 'translateX(20px)' : 'translateX(2px)',
		transition: 'background-color 300ms linear, transform 400ms ease',
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleSPAN = { ...defaultStyleSPAN, ...styleSPAN };

	/* Mouseover Styling */
	const onMouseOver = event => {
		event.preventDefault();
		event.target.style.backgroundColor = value ? colors?.dark : colors?.light;
	};
	const onMouseLeave = event => {
		event.preventDefault();
		event.target.style.backgroundColor = value ? colors?.primary : colors?.secondary;
	};

	return (
		<Switch
			checked={value}
			onChange={onChange}
			style={overrideStyleDIV}
			onMouseOver={onMouseOver}
			onMouseLeave={onMouseLeave}
			className={classNameDIV}
		>
			<span
				style={overrideStyleSPAN}
				className={classNameSPAN}
			/>
		</Switch>
	);
}

export default ToggleInput;
